import { Text } from '@salecycle/ui-component-library';
import * as React from 'react';

export interface TemplatePercentage {
  name: string;
  percentage: number;
}

export interface Props {
  templatePercentage?: TemplatePercentage;
}

export const TemplatePercentageSummary: React.FC<Props> = props =>
  props.templatePercentage ? (
    <div>
      <Text variation="primary" size={14} weight="medium">
        {props.templatePercentage.name}
      </Text>
      <br />
      <Text size={14} weight="medium">{`${props.templatePercentage.percentage}%`}</Text>
    </div>
  ) : null;
